module.exports = __webpack_public_path__ + "img/ls.633cd8a0.svg";